import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {AppComponent} from "../../app.component";

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent implements OnInit {

  @Input() application: AppComponent;
  @Output() back = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  public handleBackButton(): void {
    this.back.emit()
  }
}
